/**
 * Custom error handler that sets statusCode to show error page
 * @param status statusCode to return
 * @param message error message to return
 * @returns Error
 */

const routerError = ({ status = 500, name = '', message = '' }) => {
  const error = new (Error as any)(message);

  error.name = name || 'RouterError';
  error.statusCode = status;
  error.response = {
    status,
  };

  Error.captureStackTrace(error, routerError);

  return error;
};

export default routerError;
